module.exports = {
    // basic

    // raw
    'delete-well-group-failed-title': `No se puede eliminar el grupo de pozos`,
    'delete-well-group-failed-reason': 'Este grupo de pozos está actualmente en uso en los siguientes lugares:'
    // template
};